import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routes, SYNC_TYPE } from "../../helpers/constants";
import { Button, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getMultipleEntriesFromDB } from "../../helpers/db";
import { useFetchAndSyncData } from "../../hooks";
import { Loader } from "../../components";
import { OfflineModal, ConfirmationModal } from "../../components/Modals";
import {
  checkCatchMessage,
  manageErrorLogs,
  checkIsEnable,
  getTimeInOutDates,
  deviceDetails,
} from "../../helpers/commonFunction";
import { insertUserDataInDB } from "../../helpers/offlineDBQuery";
import { AppLogo } from "../../images";

const BrowserCompatibility = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const { syncLoader } = useSelector((state) => state.offlineReducer);

  useEffect(() => {
    const myDevice = deviceDetails();
    if (myDevice?.device?.type === "mobile") {
      navigate(routes.dashboard);
    }
    checkDataInLocalDB();
  }, []);

  const {
    syncMessage,
    offlineModal,
    confirmationModal,
    handleOfflineModal,
    handleConfirmModal,
    uploadAndFetchData,
  } = useFetchAndSyncData();

  const checkDataInLocalDB = async () => {
    try {
      const fetchData = await getMultipleEntriesFromDB([
        "addedRestaurantDetails",
        "addedRestaurantTaskNotes",
      ]);
      if (!fetchData || Object.keys(fetchData)?.length === 0) return;
      const { addedRestaurantDetails, addedRestaurantTaskNotes } = fetchData;
      if (
        addedRestaurantDetails?.length > 0 ||
        addedRestaurantTaskNotes?.length > 0
      ) {
      } else {
        checkTimeInOut();
      }
    } catch (error) {
      manageErrorLogs(error);
      checkCatchMessage(
        error?.message || "Something went wrong in browser check!",
      );
    }
  };

  const checkTimeInOut = async () => {
    const newUser = {
      ...user,
      last_updated_time: new Date(),
    };
    await insertUserDataInDB(newUser, dispatch);
  };

  const handleUserLogout = () => {
    uploadAndFetchData(SYNC_TYPE.BROWSERLOGOUT, checkTimeInOut);
  };

  return (
    <>
      {syncLoader && <Loader />}
      <div className="tc-browser-compatibility-wrapper">
        <Card className="tc-browser-compatibility-content">
          <Card.Body>
            <div className={`tc-browser-compatibility-logo mb-4 `}>
              <img src={AppLogo} alt="FTS LOGO" />
            </div>
            <Card.Title className="text-center mb-3">Access Denied</Card.Title>
            <Card.Text className="text-center">
              Please use your Smartphone!
            </Card.Text>
            <div className="mt-4 text-center">
              {user && (
                <Button
                  variant="primary"
                  type="button"
                  className="btn-min"
                  onClick={handleUserLogout}
                >
                  Logout
                </Button>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
      {offlineModal && (
        <OfflineModal show={offlineModal} onHide={handleOfflineModal} />
      )}
      {confirmationModal && (
        <ConfirmationModal
          show={confirmationModal}
          onHide={handleConfirmModal}
          title="Syncing Data"
          subTitle="Failed to sync data!"
          description="Please resync the data!"
          cancel="Cancel"
          save="Syncing"
          errors={syncMessage}
          onSubmit={handleUserLogout}
        />
      )}
    </>
  );
};

export default BrowserCompatibility;
